import type { Router } from "vue-router";
import { Trans } from "@/i18n";
import { ETranslationModule } from "@/i18n/translation";
import { isLanguageSupported } from "@/utils/localeUtils";

// Sets up navigation guards for automatic translation loading based on route metadata
export function setupTranslationNavigationGuards(router: Router) {
  router.beforeEach(async (to, from, next) => {

    const localStorageLanguage = localStorage.getItem("language");
    
    const getUserData = () => {
      try {
        const data = localStorage.getItem("userAddData");
        return data ? JSON.parse(data) : null;
      } catch (error) {
        console.error("Error parsing user data:", error);
        return null;
      }
    };
    
    const userData = getUserData();
    const userDataLang = userData?.language;

    // If the language is not set in the localStorage, set it from the user data
    if (!localStorageLanguage?.length && userDataLang?.length > 0) {
      localStorage.setItem('language', userDataLang);
    }

    // Load global translations for the current language
    await Trans.loadGlobalTranslations();

    // Load translations for the route's modules if specified
    const i18nModules = to.meta?.i18nModules as ETranslationModule[];

    if (i18nModules) {
      try {
        await Trans.loadModuleTranslations(i18nModules);
      } catch (e) {
        console.error(
          `Error loading translations for modules:`,
          e
        );
      }
    }

    // Clean up obsolete localStorage items
    // TODO: Remove this after a while
    localStorage.removeItem('currentLanguage');
    localStorage.removeItem('currentLanguageIcon');
    localStorage.removeItem('preferredLanguage');

    next();
  });
}
